<!-- Translated: skip -->
<template>
  <div class="component">
    <div class="AccomodationsFilter">
      <div class="container">
        <span>{{ /* This is just an empty flex item that makes the spacing look good! */ }}</span>
        <div :class="{field: true, date: true, disabled: ($store.state.cart.addToOrder && $store.state.cart.addToOrder.number)}">
          <div class="label-wrapper">
            <div class="label">Välj datum</div>
            <Dropdown
              prefixicon="calendar"
              prefixicon-validated="calendar-white"
              ref="dateDropdown"
              tabindex="0"
              :options="[]"
              :label="$store.state.accomodationsFilter.date.startDate ? (
                moment($store.state.accomodationsFilter.date.startDate).format('D[/]M')
                + ' - ' +
                moment($store.state.accomodationsFilter.date.endDate).format('D[/]M')
                ) : 'När som helst'"
              @clicked="openDatePicker"
              :bold-label="false"
              :validated="$store.state.accomodationsFilter.date.startDate"
              @clicked-suffix="dateClear">
            </Dropdown>
          </div>
        </div>
        <div class="field field-beds">
          <div class="label">Antal bäddar</div>
          <CounterButton label="Antal bäddar" :count="$store.state.accomodationsFilter.beds" @changedCount="awaitFilter({waitForUser: true, callback: function() { changeBeds($event); }});" />
        </div>
        <div class="field field-bedrooms">
          <div class="label">Antal sovrum</div>
          <CounterButton label="Antal sovrum" :count="$store.state.accomodationsFilter.bedrooms" @changedCount="awaitFilter({waitForUser: true, callback: function() { changeRooms($event); }});" />
        </div>
        <div class="field field-filter-button">
          <div class="label">&nbsp;</div>
          <OutlineButton class="filter-bt" label="Fler filter" closeLabel="Stäng filter" :class="{active: filtersToggle}" icon="Filter" :iconscale="1.5" :status="filtersToggle" @clicked="toggleFilters" />
        </div>
        <span class="hide-on-mobile">{{ /* This is just an empty flex item that makes the spacing look good! */ }}</span>
      </div>
    </div>
    <transition name="animate-filter">
      <AccomodationsFilterSub v-show="filtersToggle"></AccomodationsFilterSub>
    </transition>
</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import AccomodationsFilterSub from '@/components/parts/Accomodation/List/Filter/AccomodationsFilterSub';
import DatepickerButton from '@/components/components/DatepickerButton';
import OutlineButton from '@/components/deprecated/OutlineButton';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';

import {
  validStartDate,
  validEndDate,
} from '@/dates';

import API from '@/classes/API';

import moment from 'moment';

export default {
  props: ['filterObject'],
  components: {
    DatepickerButton,
    OutlineButton,
    CounterButton,
    AccomodationsFilterSub,
    Dropdown,
  },
  data() {
    return {
    };
  },
  computed: {
    date() {
      return this.$store.state.accomodationsFilter.date;
    },
    ...mapGetters([
      'filtersToggle',
      'datepickerToggle',
      'bedsCount',
      'roomsCount',
    ]),
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
    validEndDate() {
      return validEndDate({
        startDate: this.startDate,
        validEndDates: this.validEndDates,
      });
    },
  },
  async mounted() {
    if (this.$store.state.accomodationsFilter.date.endDate) {
      this.updateAvailableUnits(this.$store.state.accomodationsFilter.date.startDate,
        this.$store.state.accomodationsFilter.date.endDate);
    }
  },
  methods: {
    ...mapMutations([
      'changeBeds',
      'changeRooms',
      'toggleDatepicker',
      'toggleMap',
      'toggleFilters',
      'openModal',
      'closeModal',
      'awaitFilter',
      'setAccomodationsFilterStartDate',
      'setAccomodationsFilterEndDate',
      'setAccomodationsAvailableIds',
    ]),
    async updateEndDate(value) {
      const formatted = moment(value).format('YYYY-MM-DD');
      const { data } = await API.get(`/dates/valid-end-dates/${formatted}?view=object`);

      const validEndDates = [];
      const inValidEndDates = [];
      Object.entries(data).forEach((element) => {
        if (element[1].free === 1) {
          validEndDates.push(element[1].date_departure);
        } else {
          inValidEndDates.push(element[1].date_departure);
        }
      });

      return {
        valid: validEndDates,
        invalid: inValidEndDates,
      };
    },
    async openDatePicker() {
      // const $this = this;
      const { data } = await API.get('/dates/valid-start-dates?view=object');

      const validStartDates = [];
      const disabledDays = [];
      Object.entries(data).forEach((element) => {
        if (element[1].free === 1) {
          validStartDates.push(element[1].date_arrival);
        } else {
          disabledDays.push(element[1].date_arrival);
        }
      });
      this.validStartDates = validStartDates;
      this.disabledDays = disabledDays;
      // this.validStartDates = data;

      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        // validEndDates: () => this.validEndDates,
        disabledDays: this.disabledDays,
        specialDays: this.SITE_CONFIG.season.summer.special,
        onPickStart: this.updateEndDate,
        pickedStartDate: this.$store.state.accomodationsFilter.date.startDate,
        pickedEndDate: this.$store.state.accomodationsFilter.date.endDate,
        terminology: 'Sök',
        onClose: (a, b, c, d) => {
          this.changedEndDate(a, b, c, d);
        },
        infoOnPicked: this.SITE_CONFIG.accomodations.date_picker_help.pick_end ? this.SITE_CONFIG.accomodations.date_picker_help.pick_end : '',
        info: this.SITE_CONFIG.accomodations.date_picker_help.pick_day ? this.SITE_CONFIG.accomodations.date_picker_help.pick_day : '',
        extraInfo: (startDate) => {
          let msg1 = '';
          let msg2 = '';
          let msg3 = '';
          let msg4 = '';
          const msg5 = this.SITE_CONFIG.accomodations.date_picker_help.accommodation_info ? this.SITE_CONFIG.accomodations.date_picker_help.accommodation_info : '';
          const isSummer = (moment(startDate).isBetween(
            this.SITE_CONFIG.season.summer.start, this.SITE_CONFIG.season.summer.end, null, '[]'));

          if (isSummer && this.SITE_CONFIG.accomodations.date_picker_help.offert) {
            msg2 = this.SITE_CONFIG.accomodations.date_picker_help.offert;
          }
          if (!startDate) {
            msg2 = this.SITE_CONFIG.accomodations.date_limit_text;
          }

          const closed = JSON.parse(JSON.stringify(this.SITE_CONFIG.season.winter.closed)).filter(
            d => moment(d).startOf('day').isSameOrAfter(moment().startOf('day')));
          const arrival = JSON.parse(JSON.stringify(this.validStartDates));

          const arrivalAndClosed = closed.filter(c => arrival.indexOf(moment(c).format('YYYY-MM-DD')) !== -1);

          if (startDate && arrivalAndClosed.length) {
            // const ymd = arrivalAndClosed.map(d => moment(d).format('D/M')).join(', ');
            msg3 = '';
            if (this.SITE_CONFIG.accomodations.date_picker_help.closed_slopes) {
              msg3 = this.SITE_CONFIG.accomodations.date_picker_help.closed_slopes;
            }
          }

          if (this.SITE_CONFIG.accomodations.date_picker_help.saturday
            && startDate && moment(startDate).isoWeekday() === 6) {
            msg1 = this.SITE_CONFIG.accomodations.date_picker_help.saturday;
          }

          if (this.SITE_CONFIG.accomodations.date_picker_help.special_info1) {
            msg4 = this.SITE_CONFIG.accomodations.date_picker_help.special_info1;
          }
          return [msg1, msg2, msg3, msg4, msg5];
        },
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
      }]);
    },
    changedStartDate(value) {
      this.updateEndDate(value);
      this.awaitFilter();
    },
    async updateAvailableUnits(a, b) {
      const startFormatted = moment(a).format('YYYY-MM-DD');
      const endFormatted = moment(b).format('YYYY-MM-DD');
      const { data } = await API.get(`/dates/units-available/${startFormatted}/${endFormatted}`);
      this.setAccomodationsAvailableIds(data);

      window.prices = data; // Yeah, I know...
    },
    changedEndDate(a, b, c, d) {
      const $this = this;

      const start = moment(a);
      const end = moment(b);
      const diff = end.diff(start, 'days');
      let includesClosedDate = false;
      let i = 0;

      while (i <= diff) {
        const dateToCheck = start.clone().add((i), 'days').format('YYYY-MM-DD');
        console.log(dateToCheck);

        if (this.SITE_CONFIG.season.summer.special.indexOf(dateToCheck) === -1) {
          includesClosedDate = true;
        }

        i += 1;
      }

      // Todo: temporary during last days of summer season
      // includesClosedDate = false;

      if (d && includesClosedDate) {
        this.openModal(['SummerConfirmationModal', {
          startDate: a,
          endDate: b,
          click: () => {
            $this.doChangeEndDate(a, b);
          },
          cancel: () => {
            $this.openDatePicker();
          },
        }]);

        this.openModal(['GeneralModal', {}]);
      } else {
        this.doChangeEndDate(a, b);
      }
    },
    doChangeEndDate(a, b) {
      this.updateAvailableUnits(a, b);
      this.setAccomodationsFilterStartDate(a);
      this.setAccomodationsFilterEndDate(b);
      this.closeModal();
      this.awaitFilter();
    },
    dateClear() {
      this.$store.state.accomodationsFilter.date = {
        startDate: null,
        endDate: null,
      };
    },
    moment(a) {
      return moment(a);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.disabled
  disabled()

.unavailable
  unavailable()

.component
  transition-slide('animate-filter')

.AccomodationsFilter
  width 100%
  background-color pale-sky
  box-shadow inset 0 0 12px 0 rgba(0, 0, 0, 0.08)


.container
  max-width container-width
  margin-right auto
  margin-left auto
  display flex
  flex-wrap wrap
  justify-content space-between
  padding 20px 0
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile
    justify-content space-around
    .field.date
      width 100%
      +max-tablet()
        width 40%
      +max-mobile()
          width 100%
    .field
      margin-top: 0px
      +max-mobile()
        margin-top: 20px
    .filter-bt
      position: relative;
      +max-mobile()
        top: -8px

.label
  font-weight bold
  text-transform uppercase
  font-size 11px
  margin-bottom space-1
  text-align center
  +max-mobile()
    text-align: left

.field-beds
  display block
  +max-xs-mobile()
    display none

.field-bedrooms
  display block
  +max-xs-mobile()
    display none

+min-tablet()
  .field-beds, .field-bedrooms
    .wrapper
      padding-top 5px

.hide-on-mobile
  +max-mobile()
    display none

+max-mobile()
  .field.date
    text-align: center
    .label-wrapper
      display inline-block
      min-width 280px
      margin-left auto
      margin-right auto

.field-filter-button
  & > .label
    padding-top 6px
  +max-mobile()
    margin-top 0px !important
</style>



// WEBPACK FOOTER //
// AccomodationsFilter.vue?2f1c210a